import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { B as classNames } from './utils2.js';

const mapyReviewPhotoItemCss = ":host{display:block}.mapy-review-photo-item{display:flex;width:100%;height:72px;box-sizing:border-box;position:relative;border-radius:8px;overflow:hidden}.delete-btn{position:absolute;left:4px;top:4px;background:rgba(0, 0, 0, 0.6);border-radius:100%;cursor:pointer;z-index:5;padding:3px;border:none}.delete-btn svg{fill:#fff;width:16px;height:16px;display:block}.overlay{position:absolute;left:0;top:0;right:0;bottom:0;background:rgba(255, 255, 255, 0.75);z-index:4}.overlay.rejected{left:0 !important;background:rgba(216, 56, 56, 0.8)}.image-cont{position:absolute;left:0;top:0;right:0;bottom:0;z-index:3;overflow:hidden}.icon-warn-filled{position:absolute;right:10px;bottom:11px;fill:rgba(255, 255, 255, 0.7);width:20px;height:20px;z-index:4}.image-cont img{width:100%;height:100%;object-fit:cover}";
const MapyReviewPhotoItemStyle0 = mapyReviewPhotoItemCss;

const MapyReviewPhotoItem = /*@__PURE__*/ proxyCustomElement(class MapyReviewPhotoItem extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.photoDelete = createEvent(this, "photoDelete", 1);
        this.onClick = (event) => {
            event.stopPropagation();
            event.preventDefault();
            this.photoDelete.emit({});
        };
        this.src = "";
        this.percent = 100;
        this.rejected = false;
        this.anonymous = false;
    }
    render() {
        return (h(Host, { key: '26cba8b4432a6da0c9c2d86455f0a0863916843c' }, h("div", { key: '0f544f210b52d00370a8a99e63a856b75adcac73', class: "mapy-review-photo-item" }, h("button", { key: '14eef2b5a513f525077d6b39ab3c9a66ccd420f4', type: "button", class: "delete-btn", onClick: this.onClick }, h("svg", { key: '933a856c1874c5f1a8d5b0c4dd844e00481868e9', x: "0px", y: "0px", viewBox: "0 0 16 16", class: "icon icon-delete" }, h("g", { key: '0254e24b7736b6c8e6cb66935b27cdf4621776e9' }, h("path", { key: '33becfeea681b1d77739de2269b27c1c5d229373', d: "M4,12.7C4,13.4,4.6,14,5.3,14h5.3c0.7,0,1.3-0.6,1.3-1.3v-8H4L4,12.7L4,12.7z M12.6,2.7h-2.3L9.6,2H6.3L5.6,2.7H3.3V4h9.3 V2.7z" })))), h("span", { key: '0d32c24d5cd2d3b0e7e1b099d0e00c8062a2a0f4', class: classNames(["overlay", this.rejected ? "rejected" : ""]), style: { left: `${this.percent}%` } }), h("span", { key: 'edd4e0dc1d5a9180a695bd8c0a00d4ff8f917782', class: "image-cont" }, h("img", Object.assign({ key: '512ba323bd3690521f26c5add360b0e27de202ff', src: this.src, alt: "" }, this.anonymous ? { crossOrigin: "anonymous" } : {}))), this.rejected && h("svg", { key: '555a88bd9cded004ac2521e274312420486e1cc4', class: "icon-warn-filled", viewBox: "0 0 20 17", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'd759fd2c051561015f030512f02878b9b5708970', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9.12589 0.573439C9.50689 -0.11237 10.4932 -0.112371 10.8742 0.573439L19.1747 15.5143C19.545 16.1808 19.063 17 18.3005 17H1.69956C0.937074 17 0.455106 16.1808 0.825401 15.5143L9.12589 0.573439ZM11 15H9.00004V13H11V15ZM9.00004 11H11V4.99996H9.00004V11Z" })))));
    }
    static get style() { return MapyReviewPhotoItemStyle0; }
}, [1, "mapy-review-photo-item", {
        "src": [513],
        "percent": [514],
        "rejected": [516],
        "anonymous": [516]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["mapy-review-photo-item"];
    components.forEach(tagName => { switch (tagName) {
        case "mapy-review-photo-item":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, MapyReviewPhotoItem);
            }
            break;
    } });
}
defineCustomElement();

export { MapyReviewPhotoItem as M, defineCustomElement as d };

//# sourceMappingURL=mapy-review-photo-item2.js.map